export const scrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '4px',
    backgroundColor: 'transparent',
  },
  '&:hover::-webkit-scrollbar': {
    backgroundColor: '#F5F5F5',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#555',
  },
};

export const slimScrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '8px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '3px',
    backgroundColor: 'rgba(255, 221, 200, 0.6)',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(255, 221, 200, 1)',
  },
  overFlowX: 'hidden',
};

export const slimScrollbarGreenStyles = {
  '&::-webkit-scrollbar': {
    width: '8px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '3px',
    backgroundColor: 'rgba(124, 174, 190, 0.20)',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(124, 174, 190, 0.20)',
  },
  overFlowX: 'hidden',
};

export const hideScrollbarStyles = {
  // Hide scrollbar for Chrome, Safari, and Opera
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  // Hide scrollbar for IE, Edge, and Firefox
  msOverflowStyle: 'none', // IE and Edge
  scrollbarWidth: 'none', // Firefox
};

export const graphLineColors = ['#001E1D', '#68B32D', '#F9BC60', '#E16162', '#60B9F9', '#9160F9'];

export const chatSlimScrollbarStyles = {
  '&::-webkit-scrollbar': {
    width: '3px',
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '100px',
    backgroundColor: '#7CAEBE',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#7CAEBE',
  },
  overflowX: 'hidden',
};

export default scrollbarStyles;
